import React from "react";
import Header from "../directives/header";
import { Container, Row, Col, Button, Card, Form } from "react-bootstrap";
import Footer from "../directives/footer";
import "../css/launchprocess.css";

const Launchprocess = () => {
  return (
    <>
      <Header />
      <section className="launchprocess">
        <Container className="position-relative">
          <Row className="align-items-center">
            <Col lg={12} className="pt-4 mb-4">
              <div className="heading my-4 ">
                <h1 className="text-white fw-normal">The Launch process:</h1>
              </div>
            </Col>
            <Col lg={12} className="mb-4">
              <div className="launchContent">
                <Form>
                  <Row>
                    <Col md={6} className="mb-4">
                      <Form.Group controlId="exampleForm.ControlInput1">
                        <Form.Label>Token Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder=""
                          className="rounded-1"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-4">
                      <Form.Group controlId="exampleForm.ControlInput1">
                        <Form.Label>Chain Network</Form.Label>
                        <Form.Select aria-label="Default select example">
                          <option>Select Network</option>
                          <option value="1">Network 1</option>
                          <option value="2">Network 2</option>
                          <option value="3">Network 3</option>
                          <option value="4">Network 4</option>
                          <option value="5">Network 5</option>
                          <option value="6">Network 6</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-4">
                      <Form.Group
                        className=""
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Label>Token Address</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder=""
                          className="rounded-1"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={12} className="mb-4">
                      <Form.Group
                        className=""
                        controlId="exampleForm.ControlTextarea1"
                      >
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          className="rounded-1"
                          placeholder="Max 1000 characters"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={12} className="mb-4">
                      <Form.Group
                        className=""
                        controlId="exampleForm.ControlTextarea1"
                      >
                        <Form.Label>ADD a Brand Logo/Upload a Logo</Form.Label>
                        <div className="fileupload rounded-1">
                          <Form.Control type="file" className="rounded-1" />
                          <div className="fileuploadtext">
                            Click to upload files, or drag & drop files here
                          </div>
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-4">
                      <Form.Group controlId="exampleForm.ControlInput1">
                        <Form.Label>ADD KYC</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder=""
                          className="rounded-1"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-4">
                      <Form.Group
                        className=""
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Label>ADD Audit</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder=""
                          className="rounded-1"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} className="mb-4">
                      <div className="heading">
                        <h5 className="text-white">Tokenomics</h5>
                      </div>
                    </Col>
                    <Col md={6} className="mb-4">
                      <Form.Group controlId="exampleForm.ControlInput1">
                        <Form.Label>Token Liquidity</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Value"
                          className="rounded-1"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-4">
                      <Form.Group controlId="exampleForm.ControlInput1">
                        <Form.Label>USDT Liquidity Amount</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Value"
                          className="rounded-1"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={12} className="mb-4">
                      <Form.Group
                        className=""
                        controlId="exampleForm.ControlTextarea1"
                      >
                        <Form.Label>Whitepaper</Form.Label>
                        <Form.Control
                          type="text"
                          className="rounded-1"
                          placeholder="Add a whitepaper link here"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={12} className="mb-4">
                      <div className="heading">
                        <h5 className="text-white">
                          IMPORTANT: Special Liquidity Management SpecialLM -
                          must agree *
                        </h5>
                        <p className="text-light-grey fw-light">
                          (Here is the description for the project owners, what
                          they have to agree upon prior to listing their
                          project. This will be a contract between Unitronix and
                          the starting project that needs to be 
                          <span className="text-white fw-semibold">AGREE</span>
                           and 
                          <span className="text-white fw-bold">CONFIRM</span> by
                          the project owner)
                        </p>

                        {["checkbox"].map((type) => (
                          <div key={`default-${type}`} className="mb-3">
                            <Form.Check // prettier-ignore
                              type={type}
                              id={`default-${type}`}
                              label={
                                <>
                                  <p className="text-light-grey fw-light mb-0">
                                    Project owners must lock liquidity for a
                                    minimum of six months, during which the
                                    liquidity remains inaccessible. Safeguards
                                    are in place for companies to investigate
                                    and halt trading if a scam or suspicious
                                    transaction is spotted. In case of a
                                    confirmed scam, investors take precedence,
                                    impacting the locked liquidity. Post the
                                    lock period, project owners need approval
                                    from INFI ADMIN to access the liquidity, and
                                    must justify their request
                                  </p>
                                </>
                              }
                            />
                          </div>
                        ))}
                      </div>
                    </Col>
                    <Col md={12} className=" text-center">
                      <Button
                        variant="primary-gradient"
                        className="border-0 fw-normal px-5 mb-4"
                      >
                        Submit
                      </Button>
                      <div>
                        <p className="text-light-grey  fw-light">
                          Never submit password or credit card details through
                          workform
                        </p>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
};
export default Launchprocess;
